/*
 * File: index.ts
 * File Created: 2024-02-02 07:43:38
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-02 10:28:33
 * Modified By: Val Liu
 * -----
 */

// import { ALLOW_GENERAL_MODIFY, ALLOW_GENERAL_READ } from "@/helpers/permission-helper";
import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { IPermissionCheck, ObjectHelper, Vue } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";
// import { EUserRolePermission } from "shared-taiwan-bank-life-insurance";
const _ = UIQuick.getInstance;

// const rolePermission: EUserRolePermission = EUserRolePermission.系統維護管理作業;

@UIQuick.set()
export class User extends IQuickUnit {
    title = "w_UserList";
    path = "/user";
    icon = "fa-solid fa-user-tie";

    /// hireachy
    parents = null;
    children = () => [_`Account`, _`Organization`];

    /// file
    file = false;

    /// params
    paramsWhere = PARAMS_WHERE;
    paramsRead = function(this) {
        return ObjectHelper.deepMerge(
            PARAMS_INCLUDE.call(this),
            {
                include: {
                    _count: {
                        select: {
                            accounts: true,
                            organizations: true,
                        }
                    }
                }
            }
        );
    };
    paramsUpdate = PARAMS_INCLUDE;

    /// interfaces
    infDetail = require("raw-loader!./interfaces/user.create.interface").default;
    infRead = require("raw-loader!./interfaces/user.read.interface").default;
    infCreate = require("raw-loader!./interfaces/user.create.interface").default;
    infUpdate = require("raw-loader!./interfaces/user.create.interface").default;
    infDelete = require("raw-loader!./interfaces/user.delete.interface").default;

    // /// auth
    // allowDelete = function (this: Vue, row): boolean {
    //     if (!row) return false;
    //     /// cannot delete Admin
    //     if (row.username === "Admin") return false;
    //     /// cannot delete self
    //     if (row.username === this.$user.username) return false;
    //     return true;
    // };
    // allowRead = ALLOW_GENERAL_READ(rolePermission);
    // allowCreate = ALLOW_GENERAL_MODIFY(rolePermission);
    // allowUpdate = ALLOW_GENERAL_MODIFY(rolePermission);
    //allowDelete = ALLOW_GENERAL_MODIFY(rolePermission);
}
